/* jupyter stories: films play ONCE each time their section comes into view, hold
   on their last frame, and play again from the start when you come back (owner,
   27 Sep). Helios parts play their own segment (t0..t1) of the home-page film. */
(function(){
  var reduce = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
  var tall = window.matchMedia("(max-width:700px)");
  function src(f){ if (f && f.dataset.src) return (tall.matches && f.dataset.srct) ? f.dataset.srct : f.dataset.src; return tall.matches ? "https://cdn.shopify.com/s/files/1/0979/6252/4994/files/jxs-web-helios-helios-tall.mp4?v=1793320362" : "https://cdn.shopify.com/s/files/1/0979/6252/4994/files/jxs-web-helios-helios-wide.mp4?v=1793320362"; }
  function start(f){
    var v = f.querySelector("video"), t0 = +(f.dataset.t0 || 0);
    f._done = false;
    function go(){ try { v.currentTime = t0; } catch (e) {} v.play().catch(function(){}); }
    if (!v.getAttribute("src")){ v.preload = "auto"; v.src = src(f); v.addEventListener("loadedmetadata", go, {once:true}); v.load(); }
    else if (v.readyState < 1){ v.addEventListener("loadedmetadata", go, {once:true}); v.load(); }
    else go();
  }
  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){
      var f = e.target, v = f.querySelector("video");
      var inView = e.isIntersecting && e.intersectionRatio >= (f.classList.contains("hfh") ? .12 : .35);
      if (inView && !f._in){ f._in = true; start(f); }
      else if (!inView && f._in && e.intersectionRatio < .05){ f._in = false; if (!v.paused) v.pause(); }
    });
  }, {threshold:[0,.05,.12,.35]});
  document.querySelectorAll("figure.hf").forEach(function(f){
    var v = f.querySelector("video"), t1 = +(f.dataset.t1 || 0);
    v.loop = false;
    if (tall.matches && f.dataset.pt) v.poster = f.dataset.pt;
    if (t1) v.addEventListener("timeupdate", function(){ if (!f._done && v.currentTime >= t1){ f._done = true; v.pause(); } });
    if (!reduce) io.observe(f);
  });
  tall.addEventListener && tall.addEventListener("change", function(){
    document.querySelectorAll("figure.hf video[src]").forEach(function(v){ var f = v.closest("figure"); if (f.dataset.pt) v.poster = tall.matches ? f.dataset.pt : f.dataset.pw; v.src = src(f); if (f._in) start(f); });
  });
})();
